// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"620":"488305b5","664":"d2e68a09","760":"889d5e6d","766":"073d6f27","788":"81231d2d","863":"5ad9dad2","879":"59722848","881":"ac09f5a2","981":"5d65ac0b"}[chunkId] + ".chunk.js";
};